<template>
  <div id="purchase">
    <router-link to='/collections/bespoke-service'>
      <div class="bannerspacer"></div>
      <div class="banner">
        <div class="inner">
          <h2>
            Dovedale Design<Br/>
            Studio’S<Br/>
            Bespoke Service
          </h2>
          <div class="logo">
            <LogoMarque/>
          </div>
        </div>
      </div>
    </router-link>
    <template v-for="slug in slugs">
      <collection-items :slug="slug" :collections="collections" :options="{ customOrders: false, isPurchase: true }"/>
      <!-- :item-view-name="slug"  -->
    </template>
  </div>
</template>

<script>
// import Vue from 'vue'
// import Config from 'src/config'
// import skuItem from 'src/components/Collection__SKUs__Item'
import CollectionItems from 'src/components/Collection__SKUs'
import LogoMarque from 'src/components/LogoMarque'

// import _find from 'lodash/find'

export default {
  name: 'CollectionSKUs',
  components: { CollectionItems, LogoMarque },
  props: {
    // slug: String,
    collections: Array
  },
  data () {
    return {
      slugs: ['knives', 'humidor', 'watch-box', 'jameson-suite', 'chess-set1'],
      // purchase: [
      //   { slug: 'knives', viewName: '' }
      // ],
      // products: false,
      cart: null
    }
  }
}
</script>

<style lang="scss">
.banner {
  background-image:url('https://images.prismic.io/dovedale-deisgn-studio/c3718869-d80e-4d48-86e0-90acb98a28bb_B%26W+Janji+Table+Banner.jpg?auto=compress,format&w=2000');
  background-size:cover;
  background-position:center;
  // height: 50vh;
  background-color: #bbb;
  // margin-top: 10vh;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3vw;
  .logo {
    margin-top: 2vh;
    height: 7vh;
    width: 100%;
    display: flex;
    justify-content: center;
    svg {
      * {
        stroke: white;
      }
    }
  }
  list-style-type: none;
  width: calc(86.32812% + 1.25rem * 2);
  height: calc(86.32812vw * 0.41);
  margin: 0 auto;
  padding: 0.625rem;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-pack: center;
  justify-content: center;
  margin-top: 8rem;
}
// mobile
@media screen and (max-width: 768px) {
  .banner {
    width: auto;
    height: 100vw;
    padding: 0 2.5rem;
    font-size: 8vw;
    margin-top: 0;
    // border-top: 10rem white solid;
    // padding-top: 10rem
  }
  .bannerspacer {
    height: 5rem;
  }
}
</style>



// WEBPACK FOOTER //
// Purchase.vue?ecaa205c